// Simple component to allow for 'spacing' in a basic toolbar:
// e.g: [] <ToolbarSpacer> [] <ToolbarSpacer> []
// e.g: [] <------------- ToolbarSpacer (Grow) -------------> [][]
//
// Relies on flexGrow, so for toolbars with more complex
// layouts there may be conflict issues using this class.
//
// Set the 'grow' prop to true for grow behaviour, otherwise fixed size will
// be used.

import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Box } from '@mui/material';

const ToolbarSpacer = ({ grow, large }) => {
    if (grow === true) {
        return <Box sx={{ flexGrow: 1 }} />;
    } else if (large === true) {
        return <Box sx={{ paddingLeft: 3 }} />;
    } else {
        return <Box sx={{ paddingLeft: 1 }} />;
    }
};

ToolbarSpacer.propTypes = {
    grow: PropTypes.bool,
    large: PropTypes.bool
};

export default memo(ToolbarSpacer);
